import React from 'react';
import { Link, useNavigate } from 'react-router-dom';

import Card from '@/components/shared/Card';

import Skeleton from '@/components/shared/Skeleton';
import UITwoColumnWrapper from '@/components/shared/UITwoColumnWrapper';

import PropertiesDashboardSection from '@/components/dashboard/Home/PropertiesDashboardSection';
import PaymentsDashboardSection from '@/components/dashboard/Home/PaymentsDashboardSection';

import DashboardHeaderSection from '@/components/dashboard/Home/DashboardHeaderSection';
import VacantUnitsSection from '@/components/dashboard/Home/VacantUnitsSection';
import RentedPropertiesSection from '@/components/dashboard/Home/RentedPropertiesSection';
import PropertiesStatsSection from '@/components/dashboard/Home/PropertiesStatsSection';

import useGetRentedPlaces from '@/hooks/useGetRentedPlaces';
import useProperties from '@/hooks/useProperties';
import emptyLogoIcon from '@/img/logo-empty-page.svg';
import './HomePage.scss';

const baseClass = 'HomePage';

const HomePage = () => {
  const navigate = useNavigate();

  // Для HomePage завантажуємо всі дані без фільтрів та пагінації
  const { ownedProperties, isLoading, error } = useProperties();

  const { data: rentedData } = useGetRentedPlaces();

  if (error) {
    return (
      <div className={baseClass}>
        <Card className={`${baseClass}--list`}>
          <Card.Title>Error</Card.Title>
          <Card.Body>
            <p>{error}</p>
          </Card.Body>
        </Card>
      </div>
    );
  }

  if (isLoading) {
    return (
      <div className={baseClass}>
        <Card className={`${baseClass}--list`}>
          <Card.Title>Loading...</Card.Title>
          <Card.Body>
            <Skeleton isLoading={isLoading} style={{ width: '100%' }} />
          </Card.Body>
        </Card>
      </div>
    );
  }

  return (
    <>
      <DashboardHeaderSection />

      <PropertiesStatsSection
        onCardClick={(type) => console.log('Navigate to', type)}
        onMenuClick={(type) => console.log('Menu for', type)}
      />

      <UITwoColumnWrapper
        gap="large"
        spacing="tight"
        ratio="1:1"
        mobileLayout="stack"
      >
        <PropertiesDashboardSection />
        <PaymentsDashboardSection />
      </UITwoColumnWrapper>



      <VacantUnitsSection disablePagination={true} />
      {/*
      <RentedPropertiesSection />
       */}
    </>
  );
};

export default HomePage;
